const Constants = {
    MPI_HEADER_LOGO_FILENAME: 'MULTIPLAN_PS_LOGOHEADER.jpg',
    PROVIDER_SEARCH_IMAGE_FILENAME: 'MULTIPLAN_PS_HEADERIMAGE.png',
    MPI_FOOTER_LOGO_FILENAME: 'MULTIPLAN_PS_LOGOFOOTER.jpg',
    FOOTER_INFO_TXT: "MultiPlan Corporation. All Rights Reserved ",
    TERMS: " Terms",
    TERMS_LINK: "terms-link",
    TERMS_URL: "https://www.claritev.com/terms-of-use/",
    PERIOD: ".",
    PRIVACY_POLICY: " Privacy Policy",
    PRIVACY_POLICY_LINK: "privacy-policy-link",
    PRIVACY_POLICY_URL: "https://www.claritev.com/privacy-policy/",
    TRANSLATOR_SERVICE_PHONE: "866-981-7427",
    TTY_TTD_SERVICE_PHONE: "866-918-7427",
    APPLICATION_ERROR_MSG: "Oops! Something went wrong and we couldn't process your request. Please try again later.",
    HIDE_NETWORK_CODES: ["MPIAUTOMEDICAL", "MPIWORKERSCOMP"],
    CLIENTPREFIX: "CLIENT_",
    ABOVE_TEXT: "_AT",
    BELOW_TEXT: "_BT",
    MULTIPLANMEDICARE: "MultiPlan Medicare Advantage",
    RECAPTCHA_URL: "https://www.google.com/recaptcha/api.js?render=",
    GOOGLE_TAG_MANAGER: "https://www.googletagmanager.com/gtag/js?id=",
    IP_ADDRESS_URL: "https://api.ipify.org?format=json",
    HTML_PARSER_ERROR: "parsererror",
    META_DOWNTIME_START_TIME: "Downtime-StartTime",
    META_DOWNTIME_END_TIME: "Downtime-EndTime",
    TIME_ZONE_EST: "America/New_York",
};

export default Constants;